import React from 'react';
import PropTypes from 'prop-types';

export default function CrossIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.31 7.00045L13.6411 2.66936C14.1196 2.19082 14.1196 1.41498 13.6411 0.937192L13.0637 0.359803C12.585 -0.118887 11.8092 -0.118887 11.3314 0.359803L7.00045 4.69074L2.66936 0.358905C2.19082 -0.119635 1.41498 -0.119635 0.937192 0.358905L0.358905 0.936294C-0.119635 1.41498 -0.119635 2.19082 0.358905 2.66861L4.69074 7.00045L0.359803 11.3314C-0.118887 11.8101 -0.118887 12.5859 0.359803 13.0637L0.937192 13.6411C1.41573 14.1196 2.19157 14.1196 2.66936 13.6411L7.00045 9.31L11.3314 13.6411C11.8101 14.1196 12.5859 14.1196 13.0637 13.6411L13.6411 13.0637C14.1196 12.585 14.1196 11.8092 13.6411 11.3314L9.31 7.00045Z"
        fill="#E15151"
      />
    </svg>
  );
}

CrossIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

CrossIcon.defaultProps = {
  width: 14,
  height: 14,
};
